import { type CommentConstructorData } from '../../entities/Comment'
import { type CommentApiModel } from '../api-models/CommentApiModel'

export const mapCommentApiModel = (
  apiModel: CommentApiModel
): CommentConstructorData => ({
  id: apiModel.id,
  message: apiModel.comment,
  submittedAt: apiModel.submit_date,
  author: {
    id: apiModel.userprofile.id,
    firstName: apiModel.userprofile.firstName,
    lastName: apiModel.userprofile.lastName,
    profileImage: apiModel.userprofile.profile_image,
  },
})
